
export enum LogType {
    Log,
    Exception
}